import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TrSpinnerButtonDirectiveModule } from '../../directives';
import { SvgIconModule } from '../svg-icon/svg-icon.module';
import { HubBaseRegistrationComponent } from './hub-base-registration.component';

@NgModule({
    imports: [
        CommonModule,
        SvgIconModule,
        TrSpinnerButtonDirectiveModule,
    ],
    declarations: [ HubBaseRegistrationComponent ],
    exports: [ HubBaseRegistrationComponent ],
    entryComponents: [ HubBaseRegistrationComponent ],
})
export class HubBaseRegistrationModule {}
